<template>
    <div class="reg_input_list">
        <el-form ref="form" :model="form" :rules="rules" label-width="112px" size="mini" style="font-size: 14px">
            <el-row class="input_content">
                <!-- <el-col :span="24/config.columns" v-for="(item, index) in config.list" :key="index"> -->
                <el-col :span="24 / config.columns" v-for="item in config.list" :key="item.prop">
                    <el-form-item
                        v-if="item.prop === 'countryCode' || item.prop === 'provinceCode' || item.prop === 'cityCode'"
                        :label="item.label"
                        :class="getLabelClass(item)"
                        :prop="item.prop">
                        <el-select
                            :disabled="item.disabled"
                            v-model="form[item.prop]"
                            placeholder=""
                            @change="handleSelectChange($event, item.prop)"
                            filterable
                            clearable>
                            <el-option
                                v-for="(option, index) in item.options"
                                :key="index"
                                :label="option.label"
                                :value="option.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-else-if="item.type === 'select'&&item.prop==='supplierSourceWay'"
                        :label="item.label"
                        :class="getLabelClass(item)"
                        :prop="item.prop">
                        <div class="two-columns">
                            <el-select
                            :disabled="item.disabled"
                            v-model="form[item.prop]"
                            clearable
                            placeholder=""
                            @change="handleSelectChange($event, item.prop)">
                            <el-option
                                v-for="(option, code) in item.options"
                                :key="option + '_' + code"
                                :label="option.label"
                                :value="option.value"
                            >
                        </el-option>
                        </el-select>
                        <!-- 供应商来源途径 - 11 ：其他 -->
                        <el-input
                            v-if="item.prop==='supplierSourceWay'&&form['supplierSourceWay']==='11'"
                            type="text"
                            clearable
                            :disabled="item.disabled"
                            placeholder="请输入具体寻源途径"
                            maxlength="15"
                            v-model="form['specificSourceWay']"
                            show-word-limit
                            class="two-columns-input"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item
                        v-else-if="item.type === 'select'"
                        :label="item.label"
                        :class="getLabelClass(item)"
                        :prop="item.prop">

                        <el-select
                            v-if="item.prop === 'paymentTerms'"
                            :disabled="item.disabled"
                            v-model="form[item.prop]"
                            clearable
                            placeholder=""
                            @change="handleSelectChange($event, item.prop)">
                            <el-option
                                v-for="option in paymentOptArr"
                                :key="option.value"
                                :label="option.label"
                                :value="option.value"
                                :disabled="item.prop === 'paymentTerms' && option.value === IMD_PAY && imdPayDisabled"
                            ></el-option>
                        </el-select>
                        <el-select
                            v-else
                            :disabled="item.disabled"
                            v-model="form[item.prop]"
                            clearable
                            placeholder=""
                            @change="handleSelectChange($event, item.prop)">
                            <el-option
                                v-for="(option, code) in item.options"
                                :key="option + '_' + code"
                                :label="option"
                                :value="code"
                                :disabled="item.prop === 'paymentTerms' && code === IMD_PAY && imdPayDisabled"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-else-if="item.type === 'multiple'"
                        :label="item.label"
                        :class="getLabelClass(item)"
                        :prop="item.prop">
                        <el-select
                            multiple
                            :disabled="item.disabled"
                            v-model="form[item.prop]"
                            placeholder=""
                            @change="handleSelectChange($event, item.prop)">
                            <el-option
                                v-for="(option, code) in item.options"
                                :key="option + '_' + code"
                                :label="option"
                                :value="code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        :label="item.label"
                        v-else-if="item.type === 'date'"
                        :class="getLabelClass(item)"
                        :prop="item.prop">
                        <el-date-picker
                            :disabled="item.disabled"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form[item.prop]"
                            type="date"
                            :picker-options="getPickerOptions(item)"></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        :label="item.label"
                        v-else-if="item.type === 'advance'"
                        :class="getLabelClass(item)"
                        :prop="item.prop">
                        <otp-advance
                            :disabled="item.disabled"
                            :m-value="form[item.displayProp]"
                            :params="item.params"
                            @getAdvanceValue="getAdvanceValue(item.prop, item.displayProp, $event)" />
                    </el-form-item>
                    <el-form-item v-else :label="item.label" :prop="item.prop" :class="getLabelClass(item)">
                        <el-input
                            v-if="blurCodes.indexOf(item.prop) > -1"
                            :disabled="item.disabled"
                            v-model.trim="form[item.prop]"
                            placeholder=""
                            @blur="handleBlur(item.prop, form[item.prop])"></el-input>
                        <el-input
                            v-else-if="isSensitive && item.disabled && item.prop === 'idCard' && !$store.state.supplier"
                            :disabled="true"
                            :value="sensitiveValues[item.prop]"
                            placeholder=""></el-input>
                        <el-input
                            v-else
                            :disabled="item.disabled"
                            v-model.trim="form[item.prop]"
                            placeholder=""
                            @change="handleInput($event, item.prop)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- <el-button @click="handleRqruire">获取</el-button> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import otpAdvance from '@/components/lots/otpAdvance'
import { BASE_CONFIG_FIELDS, OS_LGT, COMPANY, PERSON, ABROAD, HKMCTW, TRANSPORTATION_NUM, DELIVERY_NUM, CHANGHE_CAR, CP_CHANGEHE_CAR, IMD_PAY } from '../../constant/constant.js'
import { dictWithUrl } from '@/components/lots/api'
import { getCountrys, getCommonProvinces, getCommonCitys, setCommonRegionCode } from '../../utils/getArea'
import { getSensitiveVal } from '../../utils/common.js'
import { FIELDS_EXTRA_RULES } from './fieldsRules.js'

const BLUR_KEYCODE = ['societyCreditCode', 'businessLicenseNo', 'taxRegistNo', 'orgCode']
const DICT_LIST = {
    supplierType: 'SYS_SUPPLIERS_TYPE', // 供应商类型
    businessTypeStatus: 'SYS_SUPPLIER_SERVICES_STATUS', // 业务类型状态
    property: 'SYS_SUPPLIERS_PROPERTY', // 主体性质
    propertyNature: 'SYS_SUPPLIERS_PROPERTY', // 主体性质(工作台)
    businessType: 'BID_BUSINESS_TYPE', // 业务类型
    transType: 'SU_SHIPPER_TYPE', // 承运商类别
    transportType: 'SRM_TRANSPORT_TYPE', // 运输方式
    supplierStatus: 'SYS_SUPPLIERS_STATUS', // 供应商状态
    // updateFlag: 'SYS_COMPFIRM_STATUS', // 变更状态
    groupFlag: 'SYS_SUPPLIER_YES_NO', // 是否在集团SRM备份
    supplierGrade: 'SYS_SUPPLIER_GRADE', // 供应商等级
    nature: 'SYS_SUPPLIER_NATURE', // 单位性质
    paymentType: 'SYS_PAYMENT_TYPE', // 付款方式
    paymentTerms: 'BID_PAYMENT_TERMS', // 付款条件
    // blackFlag: 'SYS_SUPPLIER_YES_NO', // 是否黑名单
    qualityIsComplete: 'SYS_SUPPLIER_YES_NO', // 资质是否齐全
    ebcuIfNewCard: 'SYS_SUPPLIER_YES_NO', // 是否新一证
    vatInvoiceFlag: 'SYS_SUPPLIER_YES_NO', // 能否提供增值税发票
    invoiceType: 'BID_INVOICE_TYPE', // 发票类型
    taxRate: 'SU_INVOICE_TAX_RATE', // 税点
    // registerCurrency: 'SU_CURRENCY', // 币种
    cooperationMode: 'SRM_COOPERATION_MODE', // 运力机制合作方式
    isControlTransport: 'SYS_SUPPLIER_YES_NO', // 是否直控运力
    serviceType: 'SRM_SERVICE_TYPE', // 服务类型
    dispatchSupplierRate: 'SRM_SUPPLIER_RATE', // 配送类型等级
    supplierSourceWay: 'SUPPLIER_SOURCE_ROUTE', // 供应商来源途径
    transportBusinessType: 'SRM_TRANSPORT_BUSINESS_TYPE', // 运输业务类型
};

export default {
    name: 'FieldInputList',
    components: { otpAdvance },
    props: {
        fields: {
            type: Object,
            default: () => {},
        },
        propertyNature: {
            type: String,
            default: () => {
                return ''
            },
        },
        businessType: {
            type: String,
            default: () => {
                return ''
            },
        },
        transType: {
            type: String,
            default: () => {
                return ''
            },
        },
        isOverseas: {
            type: String,
            default: () => {
                return ''
            },
        },
        overseaSwitch: {
            type: Boolean,
            default() {
                return true;
            }
        },
        isSensitive: {
            type: Boolean,
            default() {
                return true
            },
        },
    },
    data() {
        return {
            form: {},
            rules: {},
            formKeys: [],
            config: {
                columns: 4,
                list: [
                    // {
                    //     label: '法人代表',
                    //     value: '李小龙',
                    //     type: 'input',
                    //     disabled: true
                    // },
                    // {
                    //     label: '发票类型',
                    //     value: '',
                    //     type: 'select',
                    //     optionName: 'option1',
                    //     disabled: false
                    // },
                    // {
                    //     label: '企业成立日期',
                    //     value: '2019-11-11',
                    //     type: 'date',
                    //     disabled: false
                    // }
                ],
            },
            options: {
                option1: [
                    {
                        value: '1',
                        label: '1',
                    },
                ],
            },
            dict: {},
            provinceIndex: null,
            cityIndex: null,
            blurCodes: BLUR_KEYCODE, // 监听失焦事件的字段
            sensitiveValues: {},
            IMD_PAY,
            paymentOptArr: [], //付款条件下拉选项
        }
    },
    computed: {
        ...mapGetters(['btnPermissions']),
        // 付款条件：立即付款选项置灰
        imdPayDisabled() {
            const { propertyNature, businessType, transType } = this
            // 有 付款条件-立即付款 按钮权限 且 ((主体性质是个体，且业务类型是运输、配送，承运商类型是长合车、城配长合车) 或 (主体性质是法人，且业务类型是运输、配送))
            return !this.btnPermissions.includes('/keyData/detail-120') &&
                ((propertyNature === PERSON && [TRANSPORTATION_NUM, DELIVERY_NUM].includes(businessType) && [CHANGHE_CAR, CP_CHANGEHE_CAR].includes(transType)) ||
                (propertyNature === COMPANY && [TRANSPORTATION_NUM, DELIVERY_NUM].includes(businessType)))
        }
    },
    methods: {
        handleRqruire() {
            // window.console.log(this.form);
        },
        getLabelClass(item) {
            let className = ''
            const REQUIRED_LENGTH = 8
            // 根据label字数配置className
            if ((item.required && item.label.length > 7) || (!item.required && item.label.length > REQUIRED_LENGTH)) {
                className = 'double-line-label'
            }
            return className
        },
        formatData(data) {
            const form = {}
            const list = []
            const keys = Object.keys(data)
            const rules = {}
            const lastListItems = []
            keys.forEach(key => {
                let rule = []
                const li = {
                    prop: key,
                    label: this.getLabel(key) || data[key].name,
                    value: data[key].value,
                    type: data[key].type,
                    required: data[key].required,
                    disabled: data[key].disabled,
                }
                if (data[key].required) {
                    rule.push({ required: data[key].required, message: `${data[key].name}不能为空` })
                }
                // 判断是否添加额外校验
                const extraFlag = this.getExtraFlag(key, data)
                if (extraFlag && FIELDS_EXTRA_RULES[key]) {
                    rule = [...rule, ...FIELDS_EXTRA_RULES[key]]
                }
                rules[key] = rule
                if (data[key].type === 'select' || data[key].type === 'multiple') {
                    // supplierSourceWay: 'SUPPLIER_SOURCE_ROUTE', // 供应商来源途径
                    if(key==='supplierSourceWay'){
                        let dicData=this.dict[DICT_LIST[key]]
                        let list=[];
                        let len=Object.keys(dicData).length+1;
                        let lastRows = []
                        for(let i=1;i<len;i++){
                            for (const key in dicData) {
                                if(i===Number(key)){
                                    let row = { label: dicData[key], value: key }
                                    // 11 是其他，单独处理
                                    if(key === '11'){
                                        lastRows.push(row)
                                    } else {
                                        list.push(row);
                                    }
                                    break;
                                }
                            }
                        }
                        list = list.concat(lastRows)
                        li.options = list
                        if(data[key].value==='11'){
                            form['specificSourceWay'] =data[key].specificSourceWay
                        }
                       
                    }else{
                        li.options = this.dict[DICT_LIST[key]]
                    }
                }
                if (data[key].type === 'advance') {
                    const advanceField = BASE_CONFIG_FIELDS.filter(field => field.code === key)[0]
                    if (advanceField) {
                        li.params = advanceField.params
                        li.displayProp = advanceField.displayCode
                        form[advanceField.displayCode] = data[key].displayValue // 把需要展示的值放入form数据中
                    }
                }
                if (key === 'countryCode') {
                    getCountrys().then(res => {
                        li.options = res.filter(item => {
                            // 涉外业务类型 开关打开，且是 海外物流，主体性质是 国外 时，不显示中国选项
                            if (this.overseaSwitch && this.isOverseas === OS_LGT && this.propertyNature === ABROAD) {
                                return item.value !== '100000'
                            } else {
                                return true
                            }
                        })
                        if (!res.some(item => item.value === data[key].value)) {
                            this.$set(this.form, key, '')
                        } else {
                            this.$set(this.form, key, data[key].value)
                        }
                    })
                }
                if (key === 'provinceCode') {
                    this.provinceIndex = list.length
                    if (data['countryCode'] && data['countryCode'].value) {
                        getCommonProvinces(data['countryCode'].value).then(res => {
                            li.options = res
                            if (!res.some(item => item.value === data[key].value)) {
                                this.$set(this.form, key, '')
                            } else {
                                this.$set(this.form, key, data[key].value)
                            }
                        })
                    }
                }
                if (key === 'cityCode') {
                    this.cityIndex = list.length
                    if (data['provinceCode'] && data['provinceCode'].value) {
                        getCommonCitys(data['provinceCode'].value).then(res => {
                            li.options = res
                            if (!res.some(item => item.value === data[key].value)) {
                                this.$set(this.form, key, '')
                            } else {
                                this.$set(this.form, key, data[key].value)
                            }
                        })
                    }
                }
                if (key === 'transportBusinessType' || key === 'taxRate' || key === 'invoiceType') {
                    // 运输业务类型、税点、发票类型放到最后
                    lastListItems.push(li)
                } else {
                    list.push(li)
                }
                if (key === 'idCard' && data[key].value) {
                    this.sensitiveValues[key] = getSensitiveVal(data[key].value, 'idCard')
                }
                form[key] = data[key].value
                
            })
            this.rules = rules
            this.config.list = list.concat(lastListItems)
            this.form = form
        },
        getExtraFlag(key, data) {
            let flag = true
            // 主体形式是 国外、港澳台 时，BLUR_KEYCODE不加额外校验
            if (BLUR_KEYCODE.includes(key) && [ABROAD, HKMCTW].includes(this.propertyNature)) {
                flag = false
            }
            return flag
        },
        getAllInputs() {
            // return this.form;
            let data = null
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.idCard) {
                        this.form.idCard = this.form.idCard.toUpperCase()
                    }
                    data = JSON.parse(JSON.stringify(this.form))
                } else {
                    data = false
                }
            })
            return data
        },
        // 获取字段中文
        getLabel(key) {
            let name = ''
            BASE_CONFIG_FIELDS.forEach(item => {
                if (item.code === key) {
                    name = item.name
                }
            })
            return name
        },
        handleSelectChange(val, key) {
            if (key === 'countryCode') {
                this.form.provinceCode = null
                this.form.cityCode = null
                getCommonProvinces(val).then(res => {
                    this.config.list[this.provinceIndex].options = res
                })
            } else if (key === 'provinceCode') {
                setCommonRegionCode(val, key)
                this.form.cityCode = null
                getCommonCitys(val).then(res => {
                    this.config.list[this.cityIndex].options = res
                })
            } else if (key === 'cityCode') {
                setCommonRegionCode(val, key)
            }
        },
        handleBlur(key, val) {
            if (key === BLUR_KEYCODE[0]) {
                const START_IDX = 8
                this.form[BLUR_KEYCODE[1]] = val
                this.form[BLUR_KEYCODE[2]] = val
                this.form[BLUR_KEYCODE[3]] = [ABROAD, HKMCTW].includes(this.propertyNature) ?
                    val : val.slice(START_IDX, val.length - 1)
            }
        },
        getAdvanceValue(prop, displayProp, data) {
            this.form[prop] = data[prop]
            this.form[displayProp] = data[displayProp]
            if (prop === 'companyCode') {
                // 服务平台根据分公司筛选
                this.setAdvanceUrl(data.companyCode)
            }
        },
        setAdvanceUrl(companyCode) {
            const siteLi = this.config.list.find(li => li.prop === 'siteCode')
            if (siteLi) {
                siteLi.params.advanceUrl = companyCode ? `searchPlatform?escoStatus=ENABLE&companyCode=${companyCode}` : 'searchPlatform?escoStatus=ENABLE'
            }
        },
        handleInput(val, prop) {
            if (prop === 'idCard') {
                this.sensitiveValues.idCard = getSensitiveVal(val, 'idCard')
            }
        },
        // 设置form某个字段值
        setValue(key, value) {
            this.form[key] = value
        },
        getPickerOptions(item) {
            let po = {}
            if (item.prop === 'businessLicenseDateTo') {
                po = {
                    disabledDate: (time) => {
                        const endtime =  (new Date()).getTime()
                        return time.getTime() < endtime;
                    }
                }
            }
            return po
        },
    },
    mounted() {},
    watch: {
        fields(val) {
            // this.config.list
            const dictList = []
            for (const key in DICT_LIST) {
                if (key) {
                    dictList.push(DICT_LIST[key])
                }
            }
            dictWithUrl(dictList.join(',')).then(res => {
                this.dict = res.data

                //付款条件字典要按规定顺序进行排序
                // 按这个字典编码进行排序 ['1','50','27','28','33','29','30','31','34','32']
                const sortArr = ['1','50','27','28','33','29','30','31','34','32']
                //查找出不在编码排序内的选项
                const newOpts = Object.keys(res.data['BID_PAYMENT_TERMS']).filter(v => sortArr.indexOf(v) === -1)
                //将固定顺序的选项（已启用）与不在顺序内的选项合并，后者选项排后面
                const paymentOpts = [...(sortArr.filter(v => res.data['BID_PAYMENT_TERMS'][v])),...newOpts]

                this.paymentOptArr = paymentOpts.map(v => {
                    return {
                        label: res.data['BID_PAYMENT_TERMS'][v],
                        value: v
                    }
                })

                this.formatData(val)
                if (val.companyCode) {
                    // 服务平台根据分公司筛选
                    this.setAdvanceUrl(val.companyCode.value)
                }
            })
        },
    },
}
</script>

<style lang="less">
.reg_input_list {
    width: 100%;
    .two-columns{
        display: flex;
        .el-select {
            flex: 1;
            width: 100%;
            min-width: 60px;
        }
        .el-input {
            width: 100%;
            min-width: 60px;
        }
        .two-columns-input{
            flex: 5;
            margin-left: 5px; 
        }
    }

    .el-form-item__content {
        height: 30px;
    }

    .el-select {
        width: 100%;
        min-width: 120px;
    }

    .el-input {
        width: 100%;
        min-width: 120px;
    }

    .el-date-editor.el-input {
        width: 100%;
        min-width: 120px;
    }

    .double-line-label .el-form-item__label {
        line-height: 1.2;
    }

    .el-input.is-disabled .el-input__inner {
        color: #404040;
        background-color: #ebebe4;
        border: 1px solid #999;
    }
}
</style>
